import React from 'react';
import * as Styles from './IconAiPencil.styles';

const IconAiPencil = ({ size }) => {
  const sizes = {
    small: 16,
    medium: 24,
    large: 32,
  };
  const width = sizes[size] || sizes.medium;
  const height = sizes[size] || sizes.medium;

  return (
    <Styles.Svg
      width={width}
      height={height}
      viewBox="0 0 24 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      data-testid="IconAiPencil"
    >
      <g clipPath="url(#clip0_3756_52504)">
        <path d="M3.18739 18.5C4.40464 17.8922 5.39223 16.9046 6 15.6874C6.60777 16.9046 7.59536 17.8922 8.81261 18.5C7.59536 19.1078 6.60777 20.0954 6 21.3126C5.39223 20.0954 4.40464 19.1078 3.18739 18.5Z" stroke="url(#paint0_linear_3756_52504)" strokeWidth="1.5" strokeLinejoin="round" />
        <path d="M3.42596 12.5046C3.64194 12.3369 3.83685 12.1427 4.00566 11.926C4.17338 12.1419 4.36752 12.3368 4.58428 12.5057C4.3683 12.6734 4.17339 12.8675 4.00457 13.0843C3.83686 12.8683 3.64271 12.6734 3.42596 12.5046Z" fill="white" stroke="url(#paint1_linear_3756_52504)" strokeWidth="1.5" />
        <path d="M16.9393 20.4393C17.5251 21.0251 18.4749 21.0251 19.0607 20.4393L19.9393 19.5607C20.5251 18.9749 20.5251 18.0251 19.9393 17.4393L11.0607 8.56066C10.4749 7.97487 9.52513 7.97487 8.93934 8.56066L8.06066 9.43934C7.47487 10.0251 7.47487 10.9749 8.06066 11.5607L16.9393 20.4393Z" stroke="url(#paint2_linear_3756_52504)" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M10 13.5L13 10.5" stroke="url(#paint3_linear_3756_52504)" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M4.71973 7.22C5.96973 5.48 7.83973 4.21 9.99973 3.72C10.6397 3.58 11.3097 3.5 11.9997 3.5C14.4797 3.5 16.7397 4.51 18.3597 6.14C19.9897 7.76 20.9997 10.02 20.9997 12.5" stroke="url(#paint4_linear_3756_52504)" strokeWidth="1.5" strokeMiterlimit="10" strokeLinecap="round" />
      </g>
      <defs>
        <linearGradient id="paint0_linear_3756_52504" x1="2.10598" y1="15.4032" x2="11.788" y2="15.9963" gradientUnits="userSpaceOnUse">
          <stop stopColor="#2E93EE" />
          <stop offset="0.0348945" stopColor="#2E93EE" />
          <stop offset="0.340091" stopColor="#415ACA" />
          <stop offset="0.663707" stopColor="#5421A5" />
          <stop offset="0.708467" stopColor="#551CA2" />
          <stop offset="1" stopColor="#2E1451" />
        </linearGradient>
        <linearGradient id="paint1_linear_3756_52504" x1="2.04837" y1="10.949" x2="6.9136" y2="11.247" gradientUnits="userSpaceOnUse">
          <stop stopColor="#2E93EE" />
          <stop offset="0.0348945" stopColor="#2E93EE" />
          <stop offset="0.340091" stopColor="#415ACA" />
          <stop offset="0.663707" stopColor="#5421A5" />
          <stop offset="0.708467" stopColor="#551CA2" />
          <stop offset="1" stopColor="#2E1451" />
        </linearGradient>
        <linearGradient id="paint2_linear_3756_52504" x1="7.18547" y1="9.08065" x2="24.129" y2="10.1186" gradientUnits="userSpaceOnUse">
          <stop stopColor="#2E93EE" />
          <stop offset="0.0348945" stopColor="#2E93EE" />
          <stop offset="0.340091" stopColor="#415ACA" />
          <stop offset="0.663707" stopColor="#5421A5" />
          <stop offset="0.708467" stopColor="#551CA2" />
          <stop offset="1" stopColor="#2E1451" />
        </linearGradient>
        <linearGradient id="paint3_linear_3756_52504" x1="10.0397" y1="10.8387" x2="13.6705" y2="11.0611" gradientUnits="userSpaceOnUse">
          <stop stopColor="#2E93EE" />
          <stop offset="0.0348945" stopColor="#2E93EE" />
          <stop offset="0.340091" stopColor="#415ACA" />
          <stop offset="0.663707" stopColor="#5421A5" />
          <stop offset="0.708467" stopColor="#551CA2" />
          <stop offset="1" stopColor="#2E1451" />
        </linearGradient>
        <linearGradient id="paint4_linear_3756_52504" x1="4.9354" y1="4.51613" x2="24.4724" y2="6.68106" gradientUnits="userSpaceOnUse">
          <stop stopColor="#2E93EE" />
          <stop offset="0.0348945" stopColor="#2E93EE" />
          <stop offset="0.340091" stopColor="#415ACA" />
          <stop offset="0.663707" stopColor="#5421A5" />
          <stop offset="0.708467" stopColor="#551CA2" />
          <stop offset="1" stopColor="#2E1451" />
        </linearGradient>
        <clipPath id="clip0_3756_52504">
          <rect width="24" height="24" fill="white" transform="translate(0 0.5)" />
        </clipPath>
      </defs>
    </Styles.Svg>
  );
};

export default IconAiPencil;
